import SelectAssessment from "pages/ManagementPage/SelectAssessment/SelectAssessment";

export default SelectAssessment;
